import React from 'react';
import { Link } from 'react-router-dom';
import { Zap, Phone, Mail, MapPin, Facebook, Instagram, Linkedin } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer-bg text-white">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-8">
          {/* Logo y descripción */}
          <div>
            <div className="flex items-center space-x-3 mb-4">
              <div className="w-12 h-12 rounded-full bg-gradient-to-br from-yellow-400 to-yellow-600 flex items-center justify-center">
                <Zap className="w-7 h-7 text-blue-900" fill="currentColor" />
              </div>
              <div>
                <h3 className="text-xl font-bold heading-font">SACER Electric</h3>
                <p className="text-xs text-yellow-400">Servicios Eléctricos y Construcción SPA</p>
              </div>
            </div>
            <p className="text-sm text-gray-300 leading-relaxed">
              Especialistas en servicios eléctricos, construcción, mantención y servicios .
            </p>
          </div>

          {/* Enlaces rápidos */}
          <div>
            <h4 className="text-lg font-bold mb-4 heading-font">Enlaces Rápidos</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-sm text-gray-300 hover:text-yellow-400 transition-colors">
                  Inicio
                </Link>
              </li>
              <li>
                <Link to="/quienes-somos" className="text-sm text-gray-300 hover:text-yellow-400 transition-colors">
                  Quiénes Somos
                </Link>
              </li>
              <li>
                <Link to="/proyectos" className="text-sm text-gray-300 hover:text-yellow-400 transition-colors">
                  Proyectos
                </Link>
              </li>
              <li>
                <Link to="/contacto" className="text-sm text-gray-300 hover:text-yellow-400 transition-colors">
                  Contacto
                </Link>
              </li>
            </ul>
          </div>

          {/* Servicios */}
          <div>
            <h4 className="text-lg font-bold mb-4 heading-font">Servicios</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/area-electrica" className="text-sm text-gray-300 hover:text-yellow-400 transition-colors">
                  Área Eléctrica
                </Link>
              </li>
              <li>
                <Link to="/area-construccion" className="text-sm text-gray-300 hover:text-yellow-400 transition-colors">
                  Área Construcción
                </Link>
              </li>
              <li>
                <Link to="/area-mantencion" className="text-sm text-gray-300 hover:text-yellow-400 transition-colors">
                  Área Mantención y Servicios SPOT
                </Link>
              </li>
            </ul>
          </div>

          {/* Contacto */}
          <div>
            <h4 className="text-lg font-bold mb-4 heading-font">Contacto</h4>
            <ul className="space-y-3">
              <li className="flex items-start space-x-3">               
                <Phone className="w-5 h-5 text-yellow-400 mt-0.5 flex-shrink-0" />
                <div>
                <p><span className="text-sm text-gray-300">+56 9 66172797</span></p>               
                <p><span className="text-sm text-gray-300">+56 9 61684591</span></p>
                </div>
              </li>
              <li className="flex items-start space-x-3">
                <Mail className="w-5 h-5 text-yellow-400 mt-0.5 flex-shrink-0" />
                <div>
                <p><span className="text-sm text-gray-300">contacto@sacerelectricchile.cl</span></p>
                <p><span className="text-sm text-gray-300">administracion@sacerelectricchile.cl</span></p>
                </div>
              </li>
              <li className="flex items-start space-x-3">
                <MapPin className="w-5 h-5 text-yellow-400 mt-0.5 flex-shrink-0" />
                <span className="text-sm text-gray-300">Cochrane 639 oficina 54, Valparaiso, Chile</span>
              </li>
            </ul>

            {/* Redes sociales */}
            <div className="flex space-x-4 mt-6">
              <a
                href="#"
                className="w-10 h-10 rounded-full bg-blue-800/50 flex items-center justify-center hover:bg-yellow-400 hover:text-blue-900 transition-all duration-300"
                aria-label="Facebook"
              >
                <Facebook className="w-5 h-5" />
              </a>
              <a
                href="#"
                className="w-10 h-10 rounded-full bg-blue-800/50 flex items-center justify-center hover:bg-yellow-400 hover:text-blue-900 transition-all duration-300"
                aria-label="Instagram"
              >
                <Instagram className="w-5 h-5" />
              </a>
              <a
                href="#"
                className="w-10 h-10 rounded-full bg-blue-800/50 flex items-center justify-center hover:bg-yellow-400 hover:text-blue-900 transition-all duration-300"
                aria-label="LinkedIn"
              >
                <Linkedin className="w-5 h-5" />
              </a>
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div className="border-t border-blue-800/50 pt-8 text-center">
          <p className="text-sm text-gray-400">
            © {currentYear} SACER Electric. Todos los derechos reservados.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;